import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, MapPinIcon, XIcon } from 'lucide-react';
import { recentBuyers } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
const FIRST_DELAY = 5000;
const VISIBLE_MS = 6000;
const HIDDEN_MS = 9000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const timeout = window.setTimeout(() => {
      if (visible) {
        setVisible(false);
        setIndex(prev => (prev + 1) % recentBuyers.length);
      } else {
        setVisible(true);
      }
    }, visible ? VISIBLE_MS : index === 0 ? FIRST_DELAY : HIDDEN_MS);
    return () => window.clearTimeout(timeout);
  }, [visible, index, dismissed]);
  const buyer = recentBuyers[index];
  return <div aria-live="polite" className="pointer-events-none fixed bottom-3 left-3 z-50 max-w-[16.5rem]" data-id="element-119" data-mp="1gx2t254uzpug">
      <AnimatePresence data-id="element-120" data-mp="163mmh36s5qw3">
        {visible && !dismissed && <motion.div key={buyer.name} initial={{
        opacity: 0,
        y: 12,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.97
      }} transition={{
        duration: 0.25,
        ease: EASE
      }} className="pointer-events-auto flex items-start gap-2 rounded-xl border-2 border-navy bg-amarillo p-2.5 shadow-[0_0_0_3px_#087CF0,0_10px_24px_rgb(7_29_73/0.35)]" data-id="element-121" data-mp="1164o26qe2u2c">
            <span className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-wifi ring-2 ring-white" data-id="element-122" data-mp="x51ajqvtda4a">
              <CheckIcon size={13} aria-hidden="true" className="text-white" strokeWidth={3} data-id="element-123" data-mp="s5euzasijhsb" />
            </span>
            <div className="min-w-0" data-id="element-124" data-mp="28iwoiwazfctx">
              <p className="text-[0.72rem] font-extrabold leading-snug text-navy" data-id="element-125" data-mp="23ld8bquq4pzc">
                {buyer.name} compró el Mega Pack Instalador de Redes 📡
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-[0.65rem] font-semibold text-navy/80" data-id="element-126" data-mp="2aobbwi679qtv">
                <MapPinIcon size={10} aria-hidden="true" className="flex-shrink-0" data-id="element-127" data-mp="2fpr18mfeuji2" />
                {buyer.city}, Argentina · hace {buyer.minutes} min
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar aviso" className="flex-shrink-0 rounded p-0.5 text-navy/70 transition-colors duration-150 ease-soft hover:text-navy" data-id="element-128" data-mp="2pl2h582k1wre">
              <XIcon size={13} data-id="element-129" data-mp="21v83ioaew463" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}